import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Utymd { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '編號 (MD001) 不可空白'}) 
    @MaxLength(15,{message: '編號 (MD001) 資料太長'})
    MD001: string = '';            // 編號 15 255.255.255.255 參考POSMY  UTYJI05

    @IsNotEmpty({message: '流水號 (MD002) 不可空白'}) 
    @MaxLength(6,{message: '流水號 (MD002) 資料太長'})
    MD002: string = '';            // 流水號 6 

    @IsNotEmpty({message: '序號 (MD003) 不可空白'}) 
    @MaxLength(4,{message: '序號 (MD003) 資料太長'})
    MD003: string = '';            // 序號 4 

    @MaxLength(20,{message: '類別 (MD004) 資料太長'})
    MD004: string = '';            // 類別 20 

    @MaxLength(255,{message: '備註 (MD005) 資料太長'})
    MD005: string = '';            // 備註 255 

    @MaxLength(50,{message: '帳號 (MD006) 資料太長'})
    MD006: string = '';            // 帳號 50 

    @MaxLength(50,{message: '密碼 (MD007) 資料太長'})
    MD007: string = '';            // 密碼 50 

    @MaxLength(8,{message: '日期 (MD008) 資料太長'})
    MD008: string = '';            // 日期 8 

    @MaxLength(500,{message: '網址 (MD009) 資料太長'})
    MD009: string = '';            // 網址 500 

    @MaxLength(2000,{message: '資料 (MD010) 資料太長'})
    MD010: string = '';            // 資料 2000 

    @IsNotEmpty({message: 'customId (MD011) 不可空白'}) 
    @MaxLength(10,{message: 'customId (MD011) 資料太長'})
    MD011: string = '';            // customId 10 


}
